'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPayloadForConfirmation = exports.getPayloadForCmds = exports.getPayloadForAppsPanelStatus = exports.getPayloadForThorAppsState = exports.getPayloadForRegistration = undefined;

var _WAMConstants = require('../constants/WAMConstants');

var _GlobalData = require('../util/GlobalData');

var _GlobalData2 = _interopRequireDefault(_GlobalData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Copyright 2019 Adobe Inc. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

var getId = function getId() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

var getPayloadForRegistration = exports.getPayloadForRegistration = function getPayloadForRegistration(userId, userName, userEmail, deviceId) {
    var payloadForRegistration = {
        connection: {
            userId: userId,
            deviceId: deviceId,
            clientInfo: {
                id: getId(),
                clientType: _WAMConstants.clientTypes.ui,
                listenTo: [_WAMConstants.clientTypes.engine],
                userName: userName,
                userEmail: userEmail
            }
        }
    };
    return payloadForRegistration;
};

var getPayloadForThorAppsState = exports.getPayloadForThorAppsState = function getPayloadForThorAppsState(userId, deviceId, sapCode, version) {
    var productSapcode = sapCode || 'dummy';
    var productVersion = version || 'dummy';
    var payloadForThorAppsState = {
        messages: [{
            id: getId(),
            userContext: {
                userId: userId,
                deviceId: deviceId
            },
            clientType: _WAMConstants.clientTypes.ui,
            msgType: 'cc.command',
            msgContextId: productSapcode + '_' + productVersion,
            msgBody: {
                sapCode: productSapcode,
                version: productVersion,
                command: 'getAppsAndServicesList'
            },
            autoContext: {
                timestamp: new Date().getTime(),
                ttl: 'medium'
            },
            apiVersion: 1.0
        }]
    };
    return payloadForThorAppsState;
};

var getPayloadForAppsPanelStatus = exports.getPayloadForAppsPanelStatus = function getPayloadForAppsPanelStatus(userId, deviceId, sapCode, version) {
    var productSapcode = sapCode || 'dummy';
    var productVersion = version || 'dummy';
    var payloadForThorAppsPanelStatus = {
        messages: [{
            id: getId(),
            userContext: {
                userId: userId,
                deviceId: deviceId
            },
            clientType: _WAMConstants.clientTypes.ui,
            msgType: 'cc.command',
            msgContextId: productSapcode + '_' + productVersion,
            msgBody: {
                sapCode: productSapcode,
                version: productVersion,
                command: 'getAppsPanelInstallAvailabilityStatus'
            },
            autoContext: {
                timestamp: new Date().getTime(),
                ttl: 'medium'
            },
            apiVersion: 1.0
        }]
    };
    return payloadForThorAppsPanelStatus;
};

var getPayloadForCmds = exports.getPayloadForCmds = function getPayloadForCmds(_ref) {
    var userId = _ref.userId,
        deviceId = _ref.deviceId,
        sapCode = _ref.sapCode,
        version = _ref.version,
        commandPayload = _ref.commandPayload,
        ingestContext = _ref.ingestContext;

    var payloadForCmds = {
        messages: [{
            id: getId(),
            userContext: {
                userId: userId,
                deviceId: deviceId
            },
            clientType: _WAMConstants.clientTypes.ui,
            clientSubType: _GlobalData2.default.clientId,
            msgType: 'cc.command',
            msgContextId: sapCode + '_' + version,
            msgBody: {
                sapCode: sapCode,
                version: version,
                ingestContext: ingestContext
            },
            autoContext: {
                timestamp: new Date().getTime(),
                ttl: 'medium'
            },
            apiVersion: 1.0
        }]
    };
    if (commandPayload) {
        if (commandPayload.command) {
            payloadForCmds.messages[0].msgBody.command = commandPayload.command;
        }
        if (commandPayload.context) {
            payloadForCmds.messages[0].msgBody.context = commandPayload.context;
        }
        if (commandPayload.showDialog) {
            payloadForCmds.messages[0].msgBody.showDialog = commandPayload.showDialog;
        }
    }

    return payloadForCmds;
};

var getPayloadForConfirmation = exports.getPayloadForConfirmation = function getPayloadForConfirmation(_ref2) {
    var userId = _ref2.userId,
        deviceId = _ref2.deviceId,
        sapCode = _ref2.sapCode,
        version = _ref2.version,
        confirmationID = _ref2.confirmationID,
        confirmationType = _ref2.confirmationType,
        confirmationValue = _ref2.confirmationValue,
        confirmationCheckboxes = _ref2.confirmationCheckboxes,
        ingestContext = _ref2.ingestContext;

    var payloadForConfirmation = {
        messages: [{
            id: getId(),
            userContext: {
                userId: userId,
                deviceId: deviceId
            },
            clientType: _WAMConstants.clientTypes.ui,
            clientSubType: _GlobalData2.default.clientId,
            msgType: 'cc.confirmationResponse',
            msgContextId: sapCode + '_' + version,
            msgBody: {
                sapCode: sapCode,
                version: version,
                confirmationID: confirmationID,
                confirmationType: confirmationType,
                confirmationValue: confirmationValue,
                confirmationCheckboxes: confirmationCheckboxes,
                ingestContext: ingestContext
            },
            autoContext: {
                timestamp: new Date().getTime(),
                ttl: 'medium'
            },
            apiVersion: 1.0
        }]
    };
    return payloadForConfirmation;
};